<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <template v-slot:activator="{ on }"></template>
    <v-card v-if="selectedUser" tile class="bg-grey">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{selectedUser.Firstname}} {{selectedUser.Name}}</v-toolbar-title>
      </v-toolbar>
      <div class="container">
        <div class="text-center">
          <div class="subtitle-1 ma-1">{{$t('manageUsers')}}</div>
        </div>
        <div class="d-flex flex-wrap">
          <v-card :disabled="disabled" :loading="disabled" tile class="ma-1 pa-3" outlined>
            <div class="title">{{$t('projects')}}</div>
            <!-- <v-list-item-group v-model="selectedProjects" multiple> -->
            <div>
              <v-text-field
                v-model="searchProjects"
                clearable
                flat
                solo-inverted
                hide-details
                color="white"
                prepend-inner-icon="search"
                @click:clear="searchProjects = ''"
                :label="$t('search')"
              ></v-text-field>
            </div>
            <!-- <div>
              <v-list-item>
                <v-list-item-action>
                  <v-checkbox
                    v-model="selectAllProjects"
                    @change="onChangeSelectAllProjects"
                    color="primary"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Select All</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
            <v-divider></v-divider> -->
            <div :key="searchProjects">
              <div v-for="(project,i) in filteredProjects" :key="i" class="d-flex">
                <v-list-item :class="selectedProject ?  project.id == selectedProject.id  ? 'pink--text' : '':''">
                  <template v-slot:default="{ active, toggle }">
                    <v-list-item-action>
                      <v-checkbox
                        v-model="selectedProjects"
                        multiple
                        @change="updateUsers"
                        :value="project.id"
                        color="primary"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{project.name}}</v-list-item-title>
                      <v-list-item-subtitle>{{project.buildingName}}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-list-item>
                <div class="pa-5">
                  <v-icon
                    :color="selectedProject ?  project.id == selectedProject.id  ? 'secondary' : '':''"
                    @click="selectedProject = project"
                  >fa-arrow-right</v-icon>
                </div>
              </div>
            </div>
            <!-- </v-list-item-group> -->
          </v-card>
          <v-card :disabled="disabled" :loading="disabled" v-if="selectedProject" tile class="ma-1 pa-3" outlined>
            <div class="title">{{$t('buildingComponents')}}</div>
            <div>
              <v-text-field
                v-model="searchBuildingComponents"
                clearable
                flat
                solo-inverted
                hide-details
                color="white"
                prepend-inner-icon="search"
                @click:clear="searchBuildingComponents = ''"
                :label="$t('search')"
              ></v-text-field>
            </div>
            <!-- <div>
              <v-list-item>
                <v-list-item-action>
                  <v-checkbox
                    v-model="selectAllBuildingComponents"
                    @change="onChangeSelectAllBuildingComponents"
                    color="primary"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Select All</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div> -->
            <v-divider></v-divider>
            <div v-for="(bc,i) in filteredBuildingComponents" :key="i" class="d-flex">
              <v-list-item>
                <template v-slot:default="{ active, toggle }">
                  <v-list-item-action>
                    <v-checkbox
                      v-model="selectedBuildingComponents"
                      @change="updateUsersComponents"
                      :value="bc.id"
                      color="primary"
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{bc.name}}</v-list-item-title>
                    <!-- <v-list-item-subtitle>Building Name {{project}}</v-list-item-subtitle> -->
                  </v-list-item-content>
                </template>
              </v-list-item>
              <div class="pa-5">
                <v-icon
                  :color="selectedBuildingComponent ?  bc.id == selectedBuildingComponent.id  ? 'secondary' : '':''"
                  @click="selectedBuildingComponent = bc"
                >fa-arrow-right</v-icon>
              </div>
            </div>
          </v-card>
          <v-card
            :disabled="disabled"
            :loading="disabled"
            v-if="selectedBuildingComponent"
            tile
            class="ma-1 pa-3"
            outlined
          >
            <div class="title">
              {{$t('blueprints')}}
              <!-- <small>({{$t('todos')}})</small> -->
            </div>
            <div>
              <v-text-field
                v-model="searchBlueprints"
                clearable
                flat
                solo-inverted
                hide-details
                color="white"
                prepend-inner-icon="search"
                @click:clear="searchBlueprints = ''"
                :label="$t('search')"
              ></v-text-field>
            </div>
            <!-- <div>
              <v-list-item>
                <v-list-item-action>
                  <v-checkbox
                    v-model="selectAllBlueprints"
                    @change="onChangeSelectAllBlueprints"
                    color="primary"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Select All</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div> -->
            <v-divider></v-divider>
            <div v-for="(blueprint,i) in filteredBlueprints" :key="i" class="d-flex">
              <v-list-item>
                <template v-slot:default="{ active, toggle }">
                  <v-list-item-action>
                    <v-checkbox
                      v-model="selectedBlueprints"
                      @change="updateUsersBlueprints"
                      :value="blueprint.id"
                      color="primary"
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{blueprint.name}}</v-list-item-title>
                    <v-list-item-subtitle></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </div>
          </v-card>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["selectedUser", "dialog"],
  data() {
    return {
      dialog: false,
      selectedUser: null,
      selectedProjects: [],
      selectedProject: null,
      projects: null,
      buildingComponents: null,
      selectedBuildingComponents: [],
      selectedBuildingComponent: null,
      blueprints: [],
      selectedBlueprints: [],
      disabled: false,
      selectAllProjects: false,
      selectAllBuildingComponents: false,
      selectAllBlueprints: false,
      searchProjects: "",
      searchBuildingComponents: "",
      searchBlueprints: ""
    };
  },
  computed: {
    filteredProjects() {
      console.log(`selectedProjects are ${this.selectedProjects}`);

      if (!this.projects) return;
      return this.projects.filter(item => {
        return item.name
          .toLowerCase()
          .includes(this.searchProjects.toLowerCase());
      });
    },
    filteredBuildingComponents() {
      if (!this.buildingComponents) return;
      return this.buildingComponents.filter(item => {
        return item.name
          .toLowerCase()
          .includes(this.searchBuildingComponents.toLowerCase());
      });
    },
    filteredBlueprints() {
      if (!this.blueprints) return;
      return this.blueprints.filter(item => {
        return item.name
          .toLowerCase()
          .includes(this.searchBlueprints.toLowerCase());
      });
    }
  },
  methods: {
    closeDialog(){
      this.$emit("close")
    },
    getProjects() {
      // this.progress = true;
      this.$http
        .getProjects(false, this.selectedUser.CustomerContactId)
        .then(res => {
          this.projects = res.data;

          console.log(`CustomerContactId is ${this.selectedUser.CustomerContactId}`);

          if (this.projects) {
            this.selectedProjects = [];
            this.projects.forEach(project => {
              if (project.installers.some(x => x.id == this.selectedUser.CustomerContactId)) {
                this.selectedProjects.push(project.id);
              }
            });
          }
        })
        .catch(error => {
          console.log(error.response.status);
        });
    },
    getBuildingComponents() {
      this.$http
        .getBuildingComponents(this.selectedProject.id)
        .then(res => {
          this.buildingComponents = res.data;

          if (this.buildingComponents) {
            this.selectedBuildingComponents = [];
            this.buildingComponents.forEach(bc => {
              if (bc.installers.some(x => x.id == this.selectedUser.CustomerContactId)) {
                this.selectedBuildingComponents.push(bc.id);
              }
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getBlueprints() {
      this.$http
        .getBlueprints(this.selectedBuildingComponent.id)
        .then(res => {
          this.blueprints = res.data;

          if (this.blueprints) {
            this.selectedBlueprints = [];
            this.blueprints.forEach(blueprint => {
              if (
                blueprint.installers.some(x => x.id == this.selectedUser.CustomerContactId)
              ) {
                this.selectedBlueprints.push(blueprint.id);
              }
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    updateUsers() {
      this.disabled = true;
      const data = {
        selectedUserId: this.selectedUser.CustomerContactId,
        entityIds: this.selectedProjects
      };
      this.$http
        .updateProjectsXInstallers(data)
        .then(res => {
          this.disabled = false;
          if (
            this.buildingComponents.some(
              x => x.projectId == this.selectedProject.id
            )
          ) {
            if (this.selectedProjects.some(s => s == this.selectedProject.id)) {
              this.buildingComponents.forEach(bc => {
                this.selectedBuildingComponents.push(bc.id);
              });

              this.blueprints.forEach(b => {
                this.selectedBlueprints.push(b.id);
              });
            } else {
              this.selectedBuildingComponents = [];
              this.selectedBlueprints = [];
            }
          }
        })
        .catch(err =>{
          this.disabled = false;
          console.log(err)
        }) ;
    },
    updateUsersComponents() {
      this.disabled = true;
      const data = {
        selectedUserId: this.selectedUser.CustomerContactId,
        entityIds: this.selectedBuildingComponents
      };

      this.$http
        .updateBuildingComponentsXInstallers(data)
        .then(res => {
          this.disabled = false;
          if (!this.selectedProjects.some(x => x == this.selectedProject.id)) {
            this.selectedProjects.push(this.selectedProject.id);
          }

          if (this.selectedBuildingComponents.length === 0) {
            this.selectedProjects = this.selectedProjects.filter(
              x => x != this.selectedProject.id
            );
          }
          if (
            this.blueprints.some(
              x => x.buildingComponentId == this.selectedBuildingComponent.id
            )
          ) {
            if (
              this.selectedBuildingComponents.some(
                s => s == this.selectedBuildingComponent.id
              )
            ) {
              this.blueprints.forEach(blueprint => {
                this.selectedBlueprints.push(blueprint.id);
              });
            } else {
              this.selectedBlueprints = [];
            }
          }
        })
        .catch(err =>{
          this.disabled = false;
          console.log(err)
        }) ;
    },
    updateUsersBlueprints() {
      this.disabled = true;
      const data = {
        selectedUserId: this.selectedUser.CustomerContactId,
        entityIds: this.selectedBlueprints,
        parentId: this.selectedBuildingComponent.id
      };

      this.$http
        .updateBlueprintXInstallers(data)
        .then(res => {
          this.disabled = false;
          // this.selectedProjects = [];
          //   this.selectedBuildingComponents = [];
          //   if(this.selectedBuildingComponents.some(x => x.))
          this.selectedBuildingComponents.push(
            this.selectedBuildingComponent.id
          );
          this.selectedProjects.push(this.selectedProject.id);
          if (this.selectedBlueprints.length === 0) {
            this.selectedBuildingComponents = this.selectedBuildingComponents.filter(
              x => x != this.selectedBuildingComponent.id
            );

            if (this.selectedBuildingComponents.length === 0) {
              this.selectedProjects = this.selectedProjects.filter(
                x => x != this.selectedProject.id
              );
            }
          }
        })
        .catch(err =>{
          this.disabled = false;
          console.log(err)
        }) ;
    },
    onChangeSelectAllProjects() {
      if (this.selectAllProjects) {
        this.projects.forEach(project => {
          if (project.installers.some(x => x.id == this.selectedUser.CustomerContactId))
            return;
          this.selectedProjects.push(project.id);
        });
        this.updateUsers();
      } else {
        this.selectedProjects = [];
        this.updateUsers();
      }
    },
    onChangeSelectAllBuildingComponents() {
      if (this.selectAllBuildingComponents) {
        this.buildingComponents.forEach(buildingComponent => {
          if (
            buildingComponent.installers.some(x => x.id == this.selectedUser.CustomerContactId)
          )
            return;
          this.selectedBuildingComponents.push(buildingComponent.id);
        });
        this.updateUsersComponents();
      } else {
        this.selectedBuildingComponents = [];
        this.updateUsersComponents();
      }
    },
    onChangeSelectAllBlueprints() {
      if (this.selectAllBlueprints) {
        this.blueprints.forEach(blueprint => {
          if (blueprint.installers.some(x => x.id == this.selectedUser.CustomerContactId))
            return;
          this.selectedBlueprints.push(blueprint.id);
        });
        this.updateUsersBlueprints();
      } else {
        this.selectedBlueprints = [];
        this.updateUsersBlueprints();
      }
    }
  },
  watch: {
    selectedUser(n, o) {
      this.selectedBuildingComponent = null;
      this.selectedProject = null;
      if (this.projects) {
        this.selectedProjects = [];
        this.projects.forEach(project => {
          if (project.installers.some(x => x.id == this.selectedUser.CustomerContactId)) {
            this.selectedProjects.push(project.id);
          }
        });
      }

      this.getProjects();
    },
    selectedProject(n, o) {
      this.buildingComponents = null;
      this.blueprints = null;
      this.selectedBuildingComponent = null;
      this.getBuildingComponents();
    },
    selectedBuildingComponent(n, o) {
      this.blueprints = null;
      this.getBlueprints();
    },
    selectedProjects(n, o) {
      if (n.length == this.projects.length) {
        this.selectAllProjects = true;
      } else {
        this.selectAllProjects = false;
      }
    },
    selectedBuildingComponents(n, o) {
      if (n.length == this.buildingComponents.length) {
        this.selectAllBuildingComponents = true;
      } else {
        this.selectAllBuildingComponents = false;
      }
    },
    selectedBlueprints(n, o) {
      if (n.length == this.blueprints.length) {
        this.selectAllBlueprints = true;
      } else {
        this.selectAllBlueprints = false;
      }
    },
    searchProjects(n,o){      
      // this.$nextTick(() => {
      //   setTimeout(() => {
      //   this.$forceUpdate();
      // }, 1000);
      // })
      
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/pages/Users/UserManager.vue